module.exports = __webpack_public_path__ + "img/Partners10.a72b0c5d.png";